import type { SVGProps } from 'react';
const SiKeyboard2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.75 12.75h8.5m-8.5 3.5h8.5m-4.5-6.5h-5a2 2 0 0 0-2 2v5.5a2 2 0 0 0 2 2h10.5a2 2 0 0 0 2-2v-5.5a2 2 0 0 0-2-2h-5.5Zm0 0v-1.5a1 1 0 0 1 1-1h4.5a1 1 0 0 0 1-1v-1.5"
    />
  </svg>
);
export default SiKeyboard2;
